import cakeService from '@/services/cakephp/index'
import nodeService from '@/services/nodejs/index'
import { set } from 'lodash'

async function fetchPOIs(state, payload) {
  state.commit('RESET_POIS')

  if (!payload.PLACE_UUID && !payload.PRODUCT_UUID) {
    state.commit('SET_POIS', [])
  } else {
    await nodeService.getPoisByVendor(payload).then((res) => {
      var response = res.data
      state.commit('SET_POIS', response)
    })
  }
}

async function pingSurveyVisitors(state, payload){
  await nodeService.pingSurveyVisitors(payload)
}
async function getPOIByUUID(state, payload) {
  if (!payload.PLACE_UUID && !payload.PRODUCT_UUID) {
    return []
  } else {
    let poiData = false
    await nodeService.getPoisByVendor(payload).then((res) => {
      poiData = res.data
    })
    return poiData
  }
}

async function fetchPublicProducts(state, place_uuid) {
  state.commit('RESET_PUBLIC_PRODUCTS')
  state.commit('SET_IS_LOADING', true)

  await nodeService.getPublicProducts(place_uuid).then((res) => {
    state.commit('SET_PUBLIC_PRODUCTS', res.data)
    state.commit('RESET_IS_LOADING')
  })
}

async function loadProducts(state) {
  const response = await cakeService.getProdutos()
  state.commit('SET_PRODUCTS', response.list)
  return response
}

async function getUF(countryId) {
  return await this.getAjax(
    'app',
    `states/${countryId}`,
    '?layout=ajax',
    'GET',
    'jsonp'
  )
}

async function getCities(ufId) {
  return await this.getAjax(
    'app',
    `cities/${ufId}`,
    '?layout=ajax',
    'GET',
    'jsonp'
  )
}

async function loadProductsMap(state) {
  const response = await cakeService.getFieldsMap('products')
  state.commit('SET_PRODUCTS_MAP', response.map)
  return response
}

async function saveProduct(state, payload) {
  state.commit('SET_IS_LOADING', true)
  const response = await nodeService.updateProduct(payload)
  state.commit('SET_IS_LOADING', false)
  return response
}

const productStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

function resetChartsCache(state) {
  state.commit('RESET_BAR_CHART_ARRECADACAO')
  state.commit('RESET_BAR_CHART_PRODUTIVIDADE')
  state.commit('RESET_BAR_CHART_HORARIO')
  state.commit('RESET_BAR_CHART_VISITANTES')
  state.commit('RESET_BAR_CHART_TAMANHO')
  state.commit('RESET_DOUGHNUT_CHART_ATRATIVO')
  state.commit('RESET_FILTERED_BILL_ITENS_AMOUNT')
  state.commit('RESET_YESTERDAY_TOTAL_CLIENTS')
  state.commit('RESET_TOMORROW_TOTAL_CLIENTS')
  state.commit('RESET_TODAY_TOTAL_CLIENTS')
  state.commit('RESET_CACHE_LIMIT_DATE')
}

const setIsLoading = (state, isLoading) => {
  state.commit('SET_IS_LOADING', isLoading)
}

export default {
  fetchPOIs,
  getPOIByUUID,
  pingSurveyVisitors,
  fetchPublicProducts,
  loadProducts,
  loadProductsMap,
  resetChartsCache,
  productStoreCommit,
  setIsLoading,
  saveProduct,
}
